import { z } from 'zod';
import { TypeOfAPIError, TypeOfAPIResponse } from '@ninja/api-client';
import { APIFactoryOptions, factory } from '../../../config';

const pagingAndSortingSchema = z.object({
	paging: z.object({
		pageSize: z.number(),
		pageNumber: z.number(),
	}),
	sorting: z.object({
		columnName: z.string(),
		sortOrder: z.union([z.literal(1), z.literal(2)]),
	}),
});

const requestSchema = z
	.object({
		screeningDateTimeFrom: z.string().optional(),
		screeningDateTimeTo: z.string().optional(),
		routineScreeningDateTimeFrom: z.string().optional(),
		routineScreeningDateTimeTo: z.string().optional(),
		screeningStatusId: z.number().optional(),
		memberName: z.string().optional(),
		memberID: z.string().optional(),
		memberDOB: z.string().optional(),
		memberNationalityId: z.number().optional(),
	})
	.merge(pagingAndSortingSchema);

const responseRecordSchema = z.object({
	recordId: z.string(),
	uniqueReferenceNumber: z.string(),
	screeningDateTime: z.string(),
	performedBy: z.string(),
	screeningType: z.string(),
	customerID: z.string(),
	customerFullNameEnglish: z.string(),
	customerFullNameArabic: z.string(),
	customerDateOfBirth: z.string(),
	customerNationality: z.string(),
	establishmentName: z.string(),
	establishmentNumber: z.string(),
	screeningStatus: z.number(),
	routineScreeningResult: z.string(),
	lastRoutineCheckDataTime: z.string(),
});

const responseSchema = z.object({
	data: z.array(responseRecordSchema),
	totalItemsCount: z.number(),
});

const postSanctionsScreeningReport = (options: APIFactoryOptions) =>
	factory(options).createAPIDefinition({
		url: '/report/sanction-log',
		method: 'POST',
		responseSchema,
		requestSchema,
		transformResponse: (response) => ({
			data: response.data.report,
			totalItemsCount: response.data.paging.totalRecords,
		}),
	});

export type PostSanctionsScreeningReportRequest = z.infer<typeof requestSchema>;

export type PostSanctionsScreeningReportResponse = TypeOfAPIResponse<ReturnType<typeof postSanctionsScreeningReport>>;

export type PostSanctionsScreeningReportRecord = z.infer<typeof responseRecordSchema>;

export type PostSanctionsScreeningReportError = TypeOfAPIError<ReturnType<typeof postSanctionsScreeningReport>>;

export default postSanctionsScreeningReport;
